import { FunctionComponent } from "react";
import Link from "next/link";
import { useTranslation } from "next-i18next/pages";
import styles from "../../styles/home/SolutionOverview.module.css";

interface SolutionCard {
  id: string;
  priceLines: string[];
  titleLines: string[];
  text: string;
  points: string[];
  ctaLabel: string;
  ctaHref: string;
}

interface SolutionOverviewProps {}

const SolutionOverview: FunctionComponent<SolutionOverviewProps> = () => {
  const { t } = useTranslation("common");
  const cards: SolutionCard[] = t("homeModern.solutions.cards", {
    returnObjects: true
  }) as SolutionCard[];
  const titleLines: string[] = t("homeModern.solutions.titleLines", {
    returnObjects: true
  }) as string[];

  return (
    <section id="solutions" className={styles.section}>
      <div className={styles.header}>
        <div>
          <div className={styles.kicker}>
            {t("homeModern.solutions.kicker")}
          </div>
          <h2 className={styles.title}>
            {titleLines.map((line: string) => (
              <span key={line}>{line}</span>
            ))}
          </h2>
        </div>
        <p className={styles.description}>
          {t("homeModern.solutions.description")}
        </p>
      </div>

      <div className={styles.grid}>
        {cards.map((card: SolutionCard, index: number) => (
          <article key={card.id} className={styles.card}>
            <div className={styles.cardTop}>
              <span className={styles.cardEyebrow}>
                {String(index + 1).padStart(2, "0")}
              </span>
              <span className={styles.cardPrice}>
                {card.priceLines.map((line: string) => (
                  <span key={line}>{line}</span>
                ))}
              </span>
            </div>
            <h3 className={styles.cardTitle}>
              {card.titleLines.map((line: string) => (
                <span key={line}>{line}</span>
              ))}
            </h3>
            <p className={styles.cardText}>{card.text}</p>

            <ul className={styles.pointList}>
              {card.points.map((point: string) => (
                <li key={point} className={styles.pointItem}>
                  {point}
                </li>
              ))}
            </ul>
            <Link href={card.ctaHref} className={styles.cardLink}>
              {card.ctaLabel} <span aria-hidden="true">→</span>
            </Link>
          </article>
        ))}
      </div>

      <div className={styles.footerCard}>
        <div>
          <div className={styles.footerTitle}>
            {t("homeModern.solutions.footerTitle")}
          </div>
          <p className={styles.footerText}>
            {t("homeModern.solutions.footerText")}
          </p>
        </div>

        <Link href="/contact" className={styles.footerButton}>
          {t("homeModern.solutions.footerCta")} <span aria-hidden="true">↗</span>
        </Link>
      </div>
    </section>
  );
};

export default SolutionOverview;
